

























import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { IDocumentImageSource } from "../../../../domain/document";
import {
  Size,
} from "../../../../domain/drawing";
import {
  DocumentPageEditor,
  PageNavigator,
  IToolTabDefinition,
} from "../contents";
import { ITabDefinition } from "../contents/tools";
import {
  SubToolContainablePaneMixin,
  BookmarkToolContainablePaneMixin,
} from "./mixins";
import { EditingDocument } from "../EditingDocument";

@Component({
  components: {
    DocumentPageEditor,
    PageNavigator,
  }
})
export default class ContentPane extends Mixins(SubToolContainablePaneMixin, BookmarkToolContainablePaneMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  @Prop()
  additionalToolTabs: IToolTabDefinition[];

  @Prop()
  additionalDocumentViewToolTabs: ITabDefinition[];

  @Prop({ default: false })
  isSubToolsDisable: boolean;

  data() {
    return {
      windowSize: ContentPane.getWindowSize(),
      shouldSwitchAutomatically: false,
      isSelectedRightSide: true,
    };
  }
  windowSize: Size;
  shouldSwitchAutomatically: boolean;
  isSelectedRightSide: boolean;

  get isRightSide(): boolean {
    return this.$configuration.behavior.document.editor.pageNavigator.isRightSide;
  }

  get editorLayoutStyle() {
    return {
      flexDirection: this.isRightSide
        ? "row"
        : "row-reverse",
    };
  }

  get contentLayoutClass(): string {
    return this.shouldShowSubToolsRightSide
      ? "horizontal"
      : "vertical";
  }

  get subToolsTabPosition(): string {
    return this.shouldShowSubToolsRightSide
      ? "left"
      : "top";
  }

  get automaticSwitchingWidth(): number {
    return this.$configuration.behavior.document.editor.panes.right.automaticSwitchingWidth;
  }

  get isSwitchableAutomatically(): boolean {
    return (0 < this.automaticSwitchingWidth)
        && !this.isEmbedded;
  }

  get shouldShowSubToolsRightSide(): boolean {
    return this.shouldSwitchAutomatically
        ? this.isSelectedRightSideAutomatically
        : this.isSelectedRightSide;
  }

  get isSelectedRightSideAutomatically(): boolean {
    return (this.automaticSwitchingWidth < this.windowSize.width);
  }

  get switcherLayoutClass(): string {
    return this.shouldShowSubToolsRightSide
      ? "vertical"
      : "horizontal";
  }

  get switcherTooltipPlacement(): string {
    return this.shouldShowSubToolsRightSide
      ? "left"
      : "top";
  }

  get autoCheckDescription(): string {
    return "ツールタブの表示位置を画面幅に応じて自動的に切り替えるかどうかを指定します。"
      + "チェックすると画面幅が"
      + this.automaticSwitchingWidth
      + "px以下になると自動的に下に表示します。";
  }

  get switchButtonDescription(): string {
    return "ツールタブの表示位置を"
      + (this.shouldShowSubToolsRightSide ? "下側" : "右側")
      + "に変更します。";
  }

  get isPageListEnable(): boolean {
    return this.readPropertyOrDefault(s => !s.isPageListDisabled, true);
  }

  get hasBookmarks(): boolean {
    const bookmarks = this.readPropertyOrDefault(s => s.bookmarks, null);
    return bookmarks && bookmarks.length > 0;
  }

  @Watch("isSwitchableAutomatically")
  onIsSwitchableAutomaticallyChanged(newValue: boolean, oldValue: boolean) {
    this.shouldSwitchAutomatically = this.isSwitchableAutomatically;
  }

  @Watch("shouldSwitchAutomatically")
  onShouldSwitchAutomaticallyChanged(newValue: boolean, oldValue: boolean) {
    if (!newValue) {  // 手動に切り替える際、位置選択は自動時の位置を維持する.
      this.isSelectedRightSide = this.isSelectedRightSideAutomatically;
    }
  }

  mounted() {
    this.shouldSwitchAutomatically = this.isSwitchableAutomatically;
    window.addEventListener("resize", e => this.onWindowResized());
  }

  onWindowResized(): void {
    this.windowSize = ContentPane.getWindowSize();
  }

  private static getWindowSize(): Size {
    return new Size(
      document.documentElement.clientWidth,
      document.documentElement.clientHeight,
    );
  }
}
